import { Alert, Box, Icon, List, Paragraph } from '@zillow/constellation-10';
import { IconInfoFilled } from '@zillow/constellation-icons';

type AttachmentGuidelinesBodyProps = {
  /** Controls text sizing and deletion notice style. */
  variant?: 'default' | 'compact';
};

const DELETION_NOTICE = 'Attachments are deleted 30 days after sending';
const listItemCss = { paddingBlock: 0 } as const;
const listItemSmCss = { paddingBlock: 0, textStyle: 'body-sm' } as const;

export default function AttachmentGuidelinesBody({ variant = 'default' }: AttachmentGuidelinesBodyProps) {
  const isCompact = variant === 'compact';
  const itemCss = isCompact ? listItemSmCss : listItemCss;

  return (
    <>
      <Paragraph textStyle={isCompact ? 'body-sm' : undefined}>
        For your protection, never share personal information in messages, such as:
      </Paragraph>
      <List.Root>
        <List.Item css={itemCss}>Social Security numbers</List.Item>
        <List.Item css={itemCss}>Credit card numbers</List.Item>
        <List.Item css={itemCss}>Driver&apos;s license numbers </List.Item>
      </List.Root>

      {isCompact ? (
        <Box css={{ display: 'flex', alignItems: 'flex-start', gap: 'tighter', marginTop: 'tighter' }}>
          <Icon size="sm" css={{ color: 'icon.feedback.info.hero', flexShrink: 0, marginTop: 'tightest' }}>
            <IconInfoFilled />
          </Icon>
          <Paragraph textStyle="body-sm">{DELETION_NOTICE}</Paragraph>
        </Box>
      ) : (
        <Alert role="alert" tone="info" css={{ marginTop: 'default' }}>
          {DELETION_NOTICE}
        </Alert>
      )}
    </>
  );
}
